import React from 'react';

import { EndOfOffers } from 'components/offers/ui-refresh/end-of-offers';
import { useLoyaltyOffersUiLoggedInQuery } from 'generated/sanity-graphql';
import { maybeLocaleImage, maybeLocaleString } from 'utils/graphql';

export const LoyaltyEndOfOffersLoggedIn = () => {
  const { data } = useLoyaltyOffersUiLoggedInQuery({
    variables: {
      id: 'feature-loyalty-offers-ui-singleton',
    },
  });
  const message = maybeLocaleString(data?.LoyaltyOffersUI?.endOfOffersLoggedIn?.endOfOffersMessage);
  const image = maybeLocaleImage(data?.LoyaltyOffersUI?.endOfOffersLoggedIn?.endOfOffersImage);
  if (!message || !image) {
    return null;
  }
  return <EndOfOffers message={message || ''} image={image} />;
};
